import React from 'react';
import { bulletListSelector } from '@atlaskit/adf-schema';
import { getListIndentLevel } from '../utils/lists';
export default function BulletList(props) {
  return /*#__PURE__*/React.createElement("ul", {
    className: bulletListSelector.substr(1),
    "data-indent-level": props.path ? getListIndentLevel(props.path) : 1
  }, props.children);
}